import Swiper, { Navigation } from "swiper";

Swiper.use([Navigation]);

export default () => ({
    carousel: null,

    init() {

        this.carousel = new Swiper(".swiper-timeline", {
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 1250,
            effect: "fade",
            loop: false,
            setWrapperSize: true,
            
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                640: {
                    slidesPerView: 1,
                },
                768: {
                    slidesPerView: 2,  
                },
                1024: {
                    slidesPerView: 3,  
                },
                1300: {
                    slidesPerView: 4,
                },

                1920: {
                    slidesPerView: 5, 
                },
            },
            on: {
                init: function () {
                    // Set widths for each slide on init
                    setSlideWidths(this);
                    this.updateSize();
                },
                resize: function () {
                    // Set widths for each slide on resize
                    setSlideWidths(this);
                    this.updateSize();
                },
            },
        });
    },
});

function setSlideWidths() {

    const timelineWidthElement = document.querySelector('.timeline-width');
    if (!timelineWidthElement) {
        return;
    }

    const pageWidth = window.innerWidth;

    if (pageWidth < 1300) {
        return;
    }

    const containerWidth = timelineWidthElement.clientWidth;
    const remainingSpace = (pageWidth - containerWidth) / 2;
    const slides = document.querySelectorAll('.swiper-timeline .swiper-slide');

    // const middleSlideWidth = containerWidth / 3;

    // for (let i = 0; i < slides.length; i++) {
    //     slides[i].style.width = middleSlideWidth + "px";
    // }

    slides[0].style.width = remainingSpace + "px";
}